import * as React from 'react';

function SvgBrightnessLowFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M12 8a4 4 0 11-8 0 4 4 0 018 0zM8.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zm0 11a.5.5 0 11-1 0 .5.5 0 011 0zm5-5a.5.5 0 110-1 .5.5 0 010 1zm-11 0a.5.5 0 110-1 .5.5 0 010 1zm9.743-4.036a.5.5 0 11-.707-.707.5.5 0 01.707.707zm-7.779 7.779a.5.5 0 11-.707-.707.5.5 0 01.707.707zm7.072 0a.5.5 0 11.707-.707.5.5 0 01-.707.707zM3.757 4.464a.5.5 0 11.707-.707.5.5 0 01-.707.707z' />
		</svg>
	);
}

export default SvgBrightnessLowFill;
